const apiConfig = {
  timeout: 300000,
  // successStatus: [200, 201],
  // bizErrorStatus: [400, 401, 500],
  SESSION_TIME_OUT_COUNTDOWN_SECOND: 9 * 60,
  SESSION_TIME_OUT_CONSIDER_SECOND: 50,
};

export default apiConfig;
